import { useEffect, useState } from "react";
import api, { getImageUrl } from "../services/api";

function AdminCategoryIcons() {
    const [icons, setIcons] = useState([]);
    const [selectedFiles, setSelectedFiles] = useState({});
    const [uploading, setUploading] = useState({});

    useEffect(() => {
        fetchIcons();
    }, []);

    const fetchIcons = async () => {
        try {
            // Fetch directly from your global menu categories
            const response = await api.get("/categories/global");
            setIcons(response.data);
        } catch (error) {
            console.log(error);
        }
    };

    const handleFileSelect = (categoryId, file) => {
        setSelectedFiles((prev) => ({ ...prev, [categoryId]: file }));
    };

    const uploadIcon = async (categoryId) => {
        const file = selectedFiles[categoryId];
        if (!file) return alert("Please choose an image first");

        setUploading((prev) => ({ ...prev, [categoryId]: true }));

        try {
            const token = localStorage.getItem("token");
            const formData = new FormData();
            formData.append("file", file);

            await api.post(
                `/categories/upload-category-image/${categoryId}`,
                formData,
                { headers: { Authorization: `Bearer ${token}` } }
            );

            alert("Category image updated!");
            setSelectedFiles((prev) => ({ ...prev, [categoryId]: null }));
            fetchIcons(); // Refresh grid
        } catch (error) {
            alert(error.response?.data?.detail || "Upload failed");
        } finally {
            setUploading((prev) => ({ ...prev, [categoryId]: false }));
        }
    };

    return (
        <>
            <style>{css}</style>
            <div className="app-container">

                {/* Header */}
                <div className="app-header">
                    <button className="back-btn" onClick={() => window.history.back()}>←</button>
                    <h1 className="header-title">🖼️ Category Icons</h1>
                </div>

                <div className="content-scroll">
                    <p className="page-desc">
                        Upload an image for each home screen category. Categories without an
                        uploaded image will keep showing their default emoji.
                    </p>

                    <div className="grid-cards">
                        {icons.map((icon) => {
                            const file = selectedFiles[icon.id];
                            const previewUrl = file ? URL.createObjectURL(file) : null;
                            const isUploading = uploading[icon.id];

                            return (
                                <div key={icon.id} className="icon-card">
                                    <div className="icon-preview-wrap">
                                        {previewUrl ? (
                                            <img src={previewUrl} alt={icon.category_name} className="icon-preview" />
                                        ) : icon.image_url ? (
                                            <img src={getImageUrl(icon.image_url)} alt={icon.category_name} className="icon-preview" />
                                        ) : (
                                            <div className="icon-placeholder">No image yet</div>
                                        )}
                                    </div>

                                    <h3 className="icon-label">{icon.category_name}</h3>

                                    <input
                                        type="file"
                                        accept="image/*"
                                        className="file-input"
                                        onChange={(e) => handleFileSelect(icon.id, e.target.files[0])}
                                    />

                                    <button
                                        className="btn-upload"
                                        onClick={() => uploadIcon(icon.id)}
                                        disabled={isUploading || !file}
                                    >
                                        {isUploading ? "Uploading..." : icon.image_url ? "Replace Image" : "Upload Image"}
                                    </button>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
        </>
    );
}

const css = `
    html, body { margin: 0; padding: 0; background-color: #f4f6f9; font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif; color: #1c1c1c; }
    .app-container { max-width: 1000px; margin: 0 auto; min-height: 100vh; background-color: #f4f6f9; display: flex; flex-direction: column; }

    .app-header { background: #ffffff; padding: 20px 40px; position: sticky; top: 0; z-index: 100; display: flex; align-items: center; gap: 16px; box-shadow: 0 2px 10px rgba(0,0,0,0.02); border-bottom: 1px solid #e2e8f0; }
    .back-btn { background: none; border: none; font-size: 24px; color: #4a5568; padding: 0; cursor: pointer; }
    .header-title { font-size: 22px; font-weight: 800; color: #1c1c1c; margin: 0; }

    .content-scroll { padding: 40px; }
    .page-desc { font-size: 14px; color: #718096; margin: 0 0 28px 0; line-height: 1.6; max-width: 600px; }

    .grid-cards { display: grid; grid-template-columns: repeat(auto-fill, minmax(220px, 1fr)); gap: 24px; }

    .icon-card { background: #ffffff; border-radius: 16px; border: 1px solid #e2e8f0; box-shadow: 0 4px 6px rgba(0,0,0,0.02); padding: 20px; display: flex; flex-direction: column; align-items: center; gap: 12px; }

    .icon-preview-wrap { width: 100%; height: 130px; border-radius: 12px; overflow: hidden; background: #f8fafc; border: 1px solid #edf2f7; display: flex; align-items: center; justify-content: center; }
    .icon-preview { width: 100%; height: 100%; object-fit: cover; }
    .icon-placeholder { font-size: 13px; color: #a0aec0; font-weight: 600; }

    .icon-label { font-size: 16px; font-weight: 800; color: #2d3748; margin: 0; }

    .file-input { width: 100%; font-size: 12px; }

    .btn-upload { width: 100%; padding: 12px; background: #ff6b00; color: #fff; border: none; border-radius: 10px; font-weight: 700; font-size: 14px; cursor: pointer; transition: opacity 0.2s; }
    .btn-upload:disabled { opacity: 0.4; cursor: not-allowed; }
    .btn-upload:not(:disabled):hover { opacity: 0.9; }

    @media (max-width: 768px) {
        .app-header { padding: 16px 20px; }
        .content-scroll { padding: 20px; }
    }
`;

export default AdminCategoryIcons;